<template>
  <div class="calendar-view-item">
    <template v-if="data && data.length">
      <div
        class="item"
        @click="showDetails(datum)"
        :key="`item_${i}`"
        v-for="(datum, i) in data"
      >
        <div class="summary">
          <p>{{ datum.project_name }}</p>
          <span v-if="datum.work_items.length">
            <i class="bdg-icon hardhat-goggles text-2xl pr-3" />
          </span>
          <span v-if="datum.procurement_items.length">
            <i class="bdg-icon van text-2xl" />
          </span>
        </div>

        <div
          :key="`detailsData_${i}`"
          class="details"
          v-on-clickaway="closeDetails"
          v-if="detailsData && detailsData === datum"
        >
          <div class="header p-2">
            <p class="text-sm font-bold">
              {{ day | moment("MMM D, YYYY") }}
              <i
                class="fal fa-times float-right close-it"
                @click.stop="closeDetails"
              />
            </p>
          </div>
          <div class="project-contract-info p-2">
            <a class="block hover:text-red" @click="goToProject">
              {{ detailsData.project_name }}
            </a>
            <a
              class="block hover:text-red"
              @click="goToContract"
              v-if="detailsData.contract_name"
            >
              {{ detailsData.contract_name }}
            </a>

            <div
              class="contract-info mt-2 mb-4"
              v-if="detailsData.primaryContactName || detailsData.fullAddress"
            >
              <div class="contact-name" v-if="detailsData.primaryContactName">
                {{ detailsData.primaryContactName }}
              </div>
              <div class="address" v-if="detailsData.fullAddress">
                {{ detailsData.fullAddress }}
              </div>
            </div>
          </div>
          <div v-if="workItemsString">
            <div class="flex items-center p-2">
              <i class="bdg-icon hardhat-goggles text-2xl pr-2" />
              <a
                class="text-sm font-bold uppercase hover:text-blue"
                @click="goToContractJobTracking"
              >
                Work
              </a>
            </div>
            <div class="work-pro-container">
              <div class="p-2 truncate">
                {{ workItemsString }}
              </div>
            </div>
          </div>
          <div v-if="procurementItemsString">
            <div class="flex items-center p-2">
              <i class="bdg-icon van text-2xl pr-2" />
              <a
                class="text-sm font-bold uppercase hover:text-blue"
                @click="goToContractProcurements"
              >
                Deliveries
              </a>
            </div>
            <div class="work-pro-container">
              <div class="p-2 truncate">
                {{ procurementItemsString }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <a class="icon-container" @click="addCrewToSchedule" v-else>
      <i class="fal fa-plus fa-fw" />
    </a>
  </div>
</template>
<script>
import { mixin as clickaway } from "vue-clickaway";
import AddCrewToScheduleForm from "../../forms/AddCrewToScheduleForm";

export default {
  name: "CalendarViewItem",
  props: ["crew", "day"],
  mixins: [clickaway],
  data() {
    return {
      detailsData: null
    };
  },
  computed: {
    data() {
      return this.crew.days[this.day];
    },
    workItemsString() {
      if (
        this.detailsData &&
        this.detailsData.work_items &&
        this.detailsData.work_items.length
      ) {
        return this.getItemsString(this.detailsData.work_items);
      }
      return null;
    },
    procurementItemsString() {
      if (
        this.detailsData &&
        this.detailsData.procurement_items &&
        this.detailsData.procurement_items.length
      ) {
        return this.detailsData.procurement_items.reduce((acc, procItem) => {
          if (procItem.items && procItem.items.length) {
            if (acc.length > 0) {
              acc += ", ";
            }
            acc += this.getItemsString(procItem.items);
          }
          return acc;
        }, "");
      }
      return null;
    }
  },
  methods: {
    getItemsString(items) {
      if (items && items.length) {
        return items.reduce((acc, item, i) => {
          if (i !== 0) {
            acc += ", ";
          }
          return `${acc}${item.name}`;
        }, "");
      }
      return null;
    },
    showDetails(data) {
      this.detailsData = data;
    },
    closeDetails() {
      this.detailsData = null;
    },
    goToProject() {
      this.$router.push({
        name: "projects-show",
        params: { id: this.detailsData.project_id }
      });
    },
    goToContract() {
      this.$router.push({
        name: "contracts-show",
        params: { id: this.detailsData.contract_id }
      });
    },
    goToContractJobTracking() {
      this.$router.push({
        name: "contract-job-tracking",
        params: { id: this.detailsData.contract_id }
      });
    },
    goToContractProcurements() {
      this.$router.push({
        name: "contract-procurements",
        params: { id: this.detailsData.contract_id }
      });
    },
    addCrewToSchedule() {
      this.$store.commit("setCreateEditComponentParams", {
        createEditComponent: AddCrewToScheduleForm,
        createEditComponentIsShown: true,
        createEditComponentData: {
          crew_identifier: this.crew.identifier,
          scheduled_for: [this.day]
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.calendar-view-item {
  .item {
    @apply relative;

    .summary {
      border-radius: 5px;
      margin: 2px;
      padding: 5px 10px;

      @apply bg-red text-white;

      &:hover {
        opacity: 0.85;
        cursor: pointer;
      }
    }

    .details {
      width: 300%;
      box-shadow: 0 7px 12px 4px rgba(0, 0, 0, 0.3);

      @apply absolute top-0 left-0 bg-white z-10;

      .header {
        //border-radius: 6px 6px 0 0;
        background-color: #628598;
        color: white;
      }
      .close-it {
        cursor: pointer;
        color: white;
      }
      .bdg-icon {
        color: #628598;
      }
      .work-pro-container {
        background-color: #eeeeee;
      }
    }
  }

  .icon-container {
    @apply flex flex-col justify-center items-center h-full w-full p-4 cursor-pointer;

    i {
      @apply invisible;
    }

    &:hover {
      i {
        @apply visible;
      }
    }
  }
}
section {
  position: relative;
}
</style>
